import { Loading, LocationIcon } from 'components'
import { Box, Flex } from 'theme-ui'
import { getCountryByCode } from 'components/Form/countryCodes'
import { TeachingLocation } from 'types/location'
import { useSingleLocation } from 'hooks/locationHooks/useSingleLocation'
import { getFromLocalizedString } from 'utils/getFromLocalizedString'

export type LocationCardProps = {
  item: TeachingLocation
  onClick: (location: TeachingLocation) => void
}

export const LocationSelectResult = ({
  item: { id },
  onClick,
}: LocationCardProps) => {
  const [location, loading] = useSingleLocation(id)
  const {
    name = '',
    addressLine = '',
    zip = '',
    city = '',
    state = '',
    countryCode = '',
  } = location ?? {}
  const country = getCountryByCode(countryCode)?.label ?? ''
  const handleClick = () => {
    if (location) onClick(location)
  }
  return (
    <Box variant="layout.result.locationSelect">
      {loading ? (
        <Loading />
      ) : (
        <Flex
          sx={{ fontSize: 2, cursor: 'pointer', lineHeight: '22px' }}
          onClick={handleClick}
        >
          <Box sx={{ pr: 20, pt: '3px' }}>
            <LocationIcon />
          </Box>
          <Box>
            <Box>{getFromLocalizedString(name)}</Box>
            <Box>{addressLine}</Box>
            <Box>
              {city}
              {state && ', '}
              {state}
            </Box>
            <Box>
              {country}
              {zip && ' - '}
              {zip}
            </Box>
          </Box>
        </Flex>
      )}
    </Box>
  )
}
